import { state, getSelectedKeyframe, pushUndo, notify, cloneKeyframe, createKeyframe } from './state.js';
import { renderGrid, renderGridProps, renderGridControls } from './grid.js';
import { showToast } from './ui.js';
import { renderAll } from './render-bridge.js';
import { deleteKeyframeFromCloud } from '../lib/storage.js';
import { isAuthenticated } from '../lib/auth.js';

// ================================================================
// KEYFRAME STRIP
// ================================================================
export function renderKeyframeStrip() {
  const strip = document.getElementById("keyframe-strip");
  strip.innerHTML = "";

  for (const kf of Object.values(state.project.keyframes)) {
    const thumb = document.createElement("div");
    thumb.className = "kf-thumb" + (kf.id === state.ui.selectedKeyframeId ? " active" : "");

    const nameEl = document.createElement("span");
    nameEl.className = "kf-thumb-name";
    nameEl.textContent = kf.name;
    thumb.appendChild(nameEl);

    if (kf._syncedAt) {
      const cloud = document.createElement("span");
      cloud.className = "kf-cloud";
      cloud.title = "Synced to cloud";
      cloud.textContent = "\u2601";
      thumb.appendChild(cloud);
    }

    thumb.addEventListener("click", () => {
      state.ui.selectedKeyframeId = kf.id;
      state.ui.selectedCell = null;
      notify("selectKeyframe");
      renderKeyframeStrip();
      renderGrid();
      renderGridProps();
      renderGridControls();
    });

    const del = document.createElement("button");
    del.className = "kf-delete";
    del.textContent = "\u00D7";
    del.title = kf._syncedAt && isAuthenticated()
      ? "Delete locally and from cloud"
      : "Delete keyframe";
    del.addEventListener("click", async (e) => {
      e.stopPropagation();
      if (Object.keys(state.project.keyframes).length <= 1) {
        showToast("Can't delete the last keyframe");
        return;
      }
      // Delete from cloud if synced (best-effort; ignored if offline)
      if (kf._syncedAt && isAuthenticated()) {
        try { await deleteKeyframeFromCloud(kf.id); }
        catch (err) { showToast("Cloud delete failed: " + err.message); return; }
      }
      pushUndo();
      for (const seq of state.project.sequences) {
        seq.steps = seq.steps.filter(s => s.keyframeId !== kf.id);
      }
      delete state.project.keyframes[kf.id];
      if (state.ui.selectedKeyframeId === kf.id) {
        state.ui.selectedKeyframeId = Object.keys(state.project.keyframes)[0];
        state.ui.selectedCell = null;
      }
      notify("deleteKeyframe");
      renderAll();
    });
    thumb.appendChild(del);
    strip.appendChild(thumb);
  }

  // Duplicate button for selected
  const dupBtn = document.createElement("button");
  dupBtn.className = "kf-add";
  dupBtn.textContent = "Duplicate";
  dupBtn.addEventListener("click", () => {
    const kf = getSelectedKeyframe();
    if (!kf) return;
    pushUndo();
    const nk = cloneKeyframe(kf);
    state.project.keyframes[nk.id] = nk;
    state.ui.selectedKeyframeId = nk.id;
    notify("duplicateKeyframe");
    renderAll();
  });
  strip.appendChild(dupBtn);

  // Add new blank
  const addBtn = document.createElement("button");
  addBtn.className = "kf-add";
  addBtn.textContent = "+ New";
  addBtn.addEventListener("click", () => {
    pushUndo();
    const gs = state.project.gridSize;
    const nk = createKeyframe("frame-" + (Object.keys(state.project.keyframes).length + 1), gs.rows, gs.cols);
    state.project.keyframes[nk.id] = nk;
    state.ui.selectedKeyframeId = nk.id;
    state.ui.selectedCell = null;
    notify("addKeyframe");
    renderAll();
  });
  strip.appendChild(addBtn);
}
